import type { FaireProductEntity } from "../../entity_types/product";

export const p_s2tjssngx3: FaireProductEntity = {
  token: "p_s2tjssngx3",
  type: "product",
  name: "Sea Salt Caramel Pouch",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c5b0dbb604fbd5ebcea326e584eb216c7e488b432ceb744057c42a0fe50ae42b.png",
  priceDollars: 4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/65a292801d5eccad339a1d322567cedbd84c9b70599a5a34aa5671b5bb8b01cf.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
